// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lgtHyK {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--spacing-1);
}

.qykMN3 {
  font-family: var(--font-family-base);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  font-size: var(--type-paragraph-md-font-size);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  height: 28px;
}

.Lyd7tW {
  display: flex;
  flex-wrap: wrap;
  align-self: stretch;
  gap: var(--spacing-3);
}

@media (max-width: 768px) {
  .Lyd7tW {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ProductsList/ProductsList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,6CAA6C;EAC7C,yDAAyD;EACzD,+BAA+B;EAC/B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--spacing-1);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  font-size: var(--type-paragraph-md-font-size);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  height: 28px;\n}\n\n.grid {\n  display: flex;\n  flex-wrap: wrap;\n  align-self: stretch;\n  gap: var(--spacing-3);\n}\n\n@media (max-width: 768px) {\n  .grid {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `lgtHyK`,
	"title": `qykMN3`,
	"grid": `Lyd7tW`
};
module.exports = ___CSS_LOADER_EXPORT___;
